import React from 'react';
import { Container, Row} from "reactstrap";
import {Link} from "react-router-dom";

const Cta = () => {
    return (
        <React.Fragment>
            <section className="section bg-light">
                        <Container>
                            <Row className="justify-content-center">
                                <div className="section-title text-center">
                                    <h3 className="title mb-3 pb-2">Find Your Dream Job - Faster, Smarter, Easier</h3>
                                    <p className="para-desc text-muted mx-auto">At Jobseekers Page, we connect ambitious professionals with top employers across industries. Whether you're a fresher exploring opportunities or an experienced candidate aiming for your next big role, our smart search tools, personalized job recommendations, and career resources are designed to help you succeed. <br/>
                                    Start your journey today-because the right job can change your life.</p>
                                    <div className="mt-4">
                                        <Link to="/signin" className="btn btn-primary btn-hover mt-2"><i className="uil uil-rocket me-1"></i> Get Started Now</Link>
                                        {/* <Link to="#" className="btn btn-outline-primary btn-hover ms-sm-1 mt-2"><i className="uil uil-capsule me-1"></i> Free Trial</Link> */}
                                    </div>
                                </div>
                            </Row>
                        </Container>
                    </section>
        </React.Fragment>
    )
}

export default Cta;
